// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"252":"b665afc6c80e4d3d46fe","561":"cf83f70d970569238905","975":"f58bed6667865d4093d2"}[chunkId] + ".js";
};